import { PRIMARY_BLUE } from '~/Constants/Colors.constants';
import { FONT_SIZE_INBETWEEN } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const AttendanceStyles = makeStyles(() => ({
  filterWraper: {
    display: 'flex',
    flexDirection: 'row',
  },
  manageBookings: {
    '&.MuiButton-root': {
      border: `1px solid ${PRIMARY_BLUE}`,
      padding: '8px 16px',
      fontSize: FONT_SIZE_INBETWEEN,
      letterSpacing: 0,
      marginTop: 16,
      width: 'max-content',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
